import * as layout from '../../components/markLayout.module.css';
import Table, { TableColumn } from '@hero/ui-kit/tables/Table';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import Tag from '@hero/ui-kit/components/Tag';
import { formatDateTime, normalizeDateString } from '@hero/hero-utils/date';
import type { ProspectDetail, ProspectState, InsuranceDiscovery } from '../../types';
type Props = {
    prospects: ProspectDetail[];
};
const stateTagType = (state: ProspectState) => {
    switch (state) {
        case 'CONVERTED':
            return 'success' as const;
        case 'STALE':
            return 'fail' as const;
        case 'ACTIVE':
            return 'primary' as const;
    }
};
const discoveryTagType = (discovery: InsuranceDiscovery) => {
    switch (discovery) {
        case 'eligible':
            return 'success' as const;
        case 'not_eligible':
            return 'fail' as const;
        case 'not_found':
            return 'warn' as const;
    }
};
const columns: TableColumn<ProspectDetail>[] = [
    {
        colKey: 'type',
        name: 'Type',
        align: 'left',
        headAlign: 'left',
        render: (p) => (
            <P noDefaultMargin strong>
                {p.prospect_type}
            </P>
        )
    },
    {
        colKey: 'state',
        name: 'State',
        align: 'left',
        headAlign: 'left',
        render: (p) => (
            <Tag type={stateTagType(p.state)} size="small">
                {p.state}
            </Tag>
        )
    },
    {
        colKey: 'date',
        name: 'Date',
        align: 'left',
        headAlign: 'left',
        render: (p) => (
            <P noDefaultMargin>{formatDateTime(normalizeDateString(p.prospect_datetime))}</P>
        )
    },
    {
        colKey: 'insurance_discovery',
        name: 'Insurance Discovery',
        align: 'left',
        headAlign: 'left',
        render: (p) =>
            p.insurance_discovery ? (
                <Tag type={discoveryTagType(p.insurance_discovery)} size="small">
                    {p.insurance_discovery.replace(/_/g, ' ')}
                </Tag>
            ) : (
                <P noDefaultMargin>—</P>
            )
    }
];
const ProspectEventsList: React.FC<Props> = ({ prospects }) => {
    if (prospects.length === 0) {
        return <P noDefaultMargin>No prospect events.</P>;
    }
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table
                columns={columns}
                data={prospects}
                rowKey="prospect_details_id"
                emptyValues="—"
            />
        </div>
    );
};
export default ProspectEventsList;
